@if (user$ | async; as user) {
    <div class="user-info">
        <div class="avatar">
            <p-avatar
                label="{{ user.firstname ? user.firstname.charAt(0) : '-' }}{{ user.lastname ? user.lastname.charAt(0) : '-' }}"
                shape="circle"
            ></p-avatar>
        </div>
        <span class="name">{{ user.firstname ? user.firstname : '-' }} {{ user.lastname ? user.lastname : '-' }}</span>
    </div>
}
